export default {
  showSidebar: true
}
